import React from "react";
import {Button, Grid, IconButton, TextField, Typography, Paper, Select, MenuItem
    ,SelectChangeEvent} from "@mui/material";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

import {mappingCrawlingInterface, mappingCrawlingInitial} from "../../../api/definition";

export function CrawlingMapping (props: any) {
    const handleMapping = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>, index: number) => {
        let list = [...props.mapping];
        list[index] = {
            ...list[index],
            [event.target.id.slice(0, -index.toString().length)]: event.target.value,
        };
        props.setMappingValues(list);
    };

    const handleAddMapping = () => {
        props.setMappingValues([...props.mapping, mappingCrawlingInitial()])
    }

    const handleMappingTypeChange = (event: SelectChangeEvent, index: number) => {
        let value = event.target.value;
        props.setMappingValues((mappingValues: Array<mappingCrawlingInterface>) => {
            const updatedValues = [...mappingValues];
            updatedValues[index] = {
                ...updatedValues[index],
                'path_type': value
            };
            return updatedValues;
        });
    }

    const handleRemoveMapping = (index: number) => {
        let list = [...props.mapping];
        list.splice(index, 1);
        props.setMappingValues(list);
    };

    return (
        <Grid item lg={12} md={12} sm={12} xs={12} sx={{mt: 2}}>
            <Grid container spacing={1}>
            <Paper
                sx={{
                    p: 1,
                    display: 'flex',
                    width: '100%',
                    bgcolor: '#eeeeee',
                    mb: 1,
                    mt: 1
                }}
            >
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container spacing={1}>
                        <Grid item lg={8} md={8} sm={8} xs={8}>
                            <Typography variant='subtitle1'>
                                Mapping - length: {props.mapping ? props.mapping.length : 0}
                            </Typography>
                        </Grid>
                        <Grid item lg={4} md={4} sm={4} xs={4}
                              sx={{
                                  display: 'flex',
                                  justifyContent: 'flex-end'
                              }}
                        >
                            {(props.type === 'postgresql' || props.type === 'mysql') &&
                            <Button
                                variant='contained'
                                onClick={props.handleCreateOpenDialog}
                            >
                                테이블 생성
                            </Button>}

                            <Button
                                variant='contained'
                                onClick={handleAddMapping}
                                sx={{ height: '100%', ml: 1 }}
                            >
                                매핑추가
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
            {props.mapping &&
                props.mapping.map((value: mappingCrawlingInterface, index: number) =>
                <Grid item lg={12} md={12} sm={12} xs={12} key={index}>
                    <Grid container spacing={1}>
                        <Grid item lg={2} md={2} sm={2} xs={2}>
                            <TextField
                                required
                                fullWidth
                                id={'path'+index}
                                label='Path'
                                value={value.path}
                                onChange={e => handleMapping(e, index)}
                            />
                        </Grid>
                        <Grid item lg={2} md={2} sm={2} xs={2}>
                            <Select
                                required
                                fullWidth
                                id={'path_type'+index}
                                value={value.path_type ?? 'tag'}
                                onChange={e => handleMappingTypeChange(e, index)}
                            >
                                <MenuItem value="tag">tag</MenuItem>
                                <MenuItem value="attr">attribute</MenuItem>
                                <MenuItem value="text">text</MenuItem>
                            </Select>
                        </Grid>
                        <Grid item lg={2} md={2} sm={2} xs={2}>
                            <TextField
                                required
                                fullWidth
                                id={'attr_name'+index}
                                label='Attribute Name'
                                value={value.attr_name}
                                onChange={e => handleMapping(e, index)}
                                disabled={value.path_type !== 'attr'}
                            />
                        </Grid>
                        <Grid item lg={2} md={2} sm={2} xs={2}>
                            <TextField
                                fullWidth
                                id={'type'+index}
                                label='Type'
                                value={value.type}
                                onChange={e => handleMapping(e, index)}
                            />
                        </Grid>
                        <Grid item lg={2} md={2} sm={2} xs={2}>
                            <TextField
                                fullWidth
                                id={'output_name'+index}
                                label='Output Name'
                                value={value.output_name}
                                onChange={e => handleMapping(e, index)}
                            />
                        </Grid>
                        <Grid item lg={2} md={2} sm={2} xs={2} sx={{
                                display: 'flex',
                                justifyContent: 'center'
                            }}
                        >
                            <IconButton
                                edge='start'
                                color='inherit'
                                onClick={() => handleRemoveMapping(index)}
                            >
                                <RemoveCircleOutlineIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>
            )}
            </Grid>
        </Grid>
    );
}